import React, { forwardRef } from 'react';
export const AccordionContentText = (StyledAccordionContentText) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledAccordionContentText ref={ref} {...props}>
        {children}
      </StyledAccordionContentText>);
});
